import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import maleAvatar from "../../../../public/img/man.png";
import femaleAvatar from "../../../../public/img/woman.png";
import { getPhaseEventDescription } from "../../../types";
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 20px;
  width: 100%;

  background-color: rgba(20, 25, 28, 1);
  border: 1px solid rgba(26, 33, 37, 1);
  border-radius: 5px;

  overflow: hidden;
`;
const Image = styled.img `
  display: block;
  width: 50px;
  height: 50px;
  object-fit: cover;
  obect-position: center;

  ${(props) => (props.isGray ? "filter: grayscale(100%)" : "")};
`;
const Name = styled.p `
  font-size: 16px;
  line-height: 19px;
  color: #fff;
`;
const Status = styled.p `
  margin-left: auto;

  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  color: ${({ color }) => color};
`;
export const EventItem = ({ event }) => {
    const eventDesc = getPhaseEventDescription(event.type);
    Image.defaultProps = {
        src: event.player.photoUrl
            ? event.player.photoUrl
            : event.player.gender === "MALE"
                ? maleAvatar
                : femaleAvatar,
    };
    const deathCases = ["KILL", "VOTES_KILL", "EXPLODE"];
    const isGray = deathCases.includes(event.type);
    return (_jsxs(Wrapper, { children: [_jsx(Image, { isGray: isGray }), _jsx(Name, { children: event.player.gameName }), _jsx(Status, Object.assign({ color: isGray ? "rgba(255, 134, 134, 1);" : "rgba(78, 158, 38, 1);" }, { children: eventDesc.name }))] }));
};
